// extracted by mini-css-extract-plugin
export var chip = "_bg-0";
export var filterDropdown = "_bg-5";
export var filterItem = "_bg-6";
export var icon = "_bg-1";
export var removeButton = "_bg-3";
export var removeIcon = "_bg-4";
export var separator = "_bg-2";